let firebaseApp = null;

export async function getFirebaseApp() {
  const { initializeApp, getApps } = await import("firebase/app");

  if (!getApps().length) {
    const config = {
      apiKey: "AIzaSyBpgQZZ5DXeG-qiaUWzN7aL4U9IWI_DKGE",
      authDomain: "boattrip-778b2.firebaseapp.com",
      databaseURL: "https://boattrip-778b2-default-rtdb.europe-west1.firebasedatabase.app",
      projectId: "boattrip-778b2",
      storageBucket: "boattrip-778b2.appspot.com",
      messagingSenderId: "525339051751",
      appId: "1:525339051751:web:8ef1d65315adc5e1640442",
      measurementId: "G-6CNV929B0R"
    };
    firebaseApp = initializeApp(config);
  }

  return firebaseApp;
}
